module.exports = __webpack_public_path__ + "img/hero-returns.739913c2.svg";